/**
 * all actions for transaction
 *
 * Created by Tom on 19/06/18
 */

import C from '../constants'

// action to hide/show the loader for the transaction
export const showTransactionLoader = booleanVal => {
    return {
        type: C.SET_TRANSACTION_LOADER,
        payload: booleanVal
    }
}

// action to set the transaction start date
export const setTransactionStartDate = momentVal => {
    return {
        type: C.SET_TRANSACTION_START_DATE,
        payload: momentVal
    }
}

// action to set the transaction end date
export const setTransactionEndDate = momentVal => {
    return {
        type: C.SET_TRANSACTION_END_DATE,
        payload: momentVal
    }
}

// action to set the transaction fetch success state
export const setTransactionFetchSuccess = booleanVal => {
    return {
        type: C.SET_TRANSACTION_FETCH_SUCCESS,
        payload: booleanVal
    }
}

// action to set the transaction data
export const setTransactionData = objectVal => {
    return {
        type: C.SET_TRANSACTION_DATA,
        payload: objectVal
    }
}

// action to set the transaction closing balance
export const setTransactionClosingBalance = numberVal => {
    return {
        type: C.SET_TRANSACTION_CLOSING_BALANCE,
        payload: numberVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */

// call the action to fetch the data
// NOTE: this will be picked up by the transaction saga (sagas/transactionSaga.js)
export const getTransactionData = () => {
    return {
        type: C.FETCH_TRANSACTION_DATA
    }
}

// call the action to clear the date range
// NOTE: this will be picked up by the transaction saga (sagas/transactionSaga.js)
export const clearDateRange = () => {
    return {
        type: C.CLEAR_DATE_RANGE
    }
}



// WEBPACK FOOTER //
// ./src/actions/transactionActions.js